import { Card } from '@nextui-org/react'
import { MouseEvent, useEffect, useState } from 'react'
import ReactFlow, { Background, BackgroundVariant, Node, useReactFlow } from 'reactflow'
import { useShallow } from 'zustand/react/shallow'
import useChartStore from '../../store/chart/useChartStore'
import { TankEdge } from './TankEdge'
import { TankNode } from './TankNode'
import { ThemeConfig } from './config'

const nodeTypes = {
  tankNode: TankNode,
}
const edgeTypes = {
  tankEdge: TankEdge,
}

export const FlowChart = () => {
  const { setSelectedEdges, setSelectedTanks, onNodesChange, onEdgesChange, nodes, edges } =
    useChartStore(
      useShallow((state) => ({
        getSchools: state.getSchools,
        setSelectedEdges: state.setSelectedEdges,
        setSelectedTanks: state.setSelectedTanks,
        onNodesChange: state.onNodesChange,
        onEdgesChange: state.onEdgesChange,
        nodes: state.nodes,
        edges: state.edges,
        setSchools: state.setSchools,
        groupId: state.groupId,
        preGroupId: state.preGroupId,
      })),
    )
  const { fitView, zoomTo } = useReactFlow()
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  useEffect(() => {
    if (nodes.length > 0 && isMobile) {
      // Mobile: zoom to 1.8 (80% more than default 1.0)
      setTimeout(() => {
        fitView({ maxZoom: 0.3, minZoom: 0.3 })
      }, 100)
    } else if (nodes.length > 0) {
      // Desktop: normal fitView
      setTimeout(() => {
        fitView()
      }, 100)
    }
  }, [nodes, isMobile, fitView])

  const onNodeClick = (event: MouseEvent, node: Node) => {
    setSelectedTanks({ schoolId: node.id, tankName: node.data.tankName })
  }

  const onNodeMouseEnter = (event: MouseEvent, node: Node) => {
    setSelectedEdges(node.id)
  }

  const onNodeMouseLeave = () => {
    setSelectedEdges(null)
  }

  return (
    <Card
      className="border shadow-none border-tdpldarkgrey border-opacity-60 bg-tdplbisque"
      data-testid="flow-chart-container"
    >
      <div style={{ width: 'full', height: '50vh' }}>
        <ReactFlow
          minZoom={0.2}
          maxZoom={isMobile ? 1.8 : 1}
          nodes={nodes}
          edges={edges}
          onNodesChange={(event) => {
            onNodesChange(event)
            if (!isMobile) {
              fitView()
            }
          }}
          onEdgesChange={onEdgesChange}
          onNodeClick={onNodeClick}
          onNodeMouseEnter={onNodeMouseEnter}
          onNodeMouseLeave={onNodeMouseLeave}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}
          proOptions={{ hideAttribution: true }}
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
          zoomOnDoubleClick={false}
          draggable={false}
          preventScrolling={false}
          onError={(event) => console.log(event)}
          data-testid="react-flow"
        >
          <Background
            gap={[ThemeConfig.unitSize * ThemeConfig.widthSize, 1000]}
            color="#9CA7A9"
            variant={BackgroundVariant.Lines}
          />
        </ReactFlow>
      </div>
    </Card>
  )
}
